import { useTranslation } from "react-i18next";
import { theme } from "../../../theme";
import TitleSmall from "../../atoms/typography/TitleSmall";
import TitleUF from "../../atoms/typography/TitleUF";
import { HorizontalSpacer } from "../../atoms/Spacers";
import TabBar from "../../molecules/TabBar";
import { useState, type FC } from "react";
import { Row } from "react-grid-system";
import { useNavigate, useLocation } from "react-router-dom";
import OutlinedButton from "../../atoms/buttons/OutlinedButton";
import { AddIcon } from "../../atoms/icons/AddIcon";
import UsersList from "../../organisms/users/UsersList";
import Modal from "../../molecules/Modal";
import ManageUserModalContent from "../../organisms/users/ManageUserModalContent";
import GroupsList from "../../organisms/users/GroupsList";
import ManageGroupModalContent from "../../organisms/users/ManageGroupModalContent";
import Toast from "../../molecules/Toast";

const tabs: Array<{ id: string; name: string }> = [
  {
    id: "users",
    name: "users.users",
  },
  {
    id: "groups",
    name: "users.groups",
  },
];

const UserManagmentPage: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const selectedTabId: "users" | "groups" =
    location.pathname === "/groups" ? "groups" : "users";

  const [addUserOpen, setAddUserOpen] = useState(false);
  const [addGroupOpen, setAddGroupOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState<string | null>(null);

  return (
    <div>
      <TitleUF color={theme.colors.primary}>
        {t("users.userManagement")}
      </TitleUF>
      <HorizontalSpacer spacing={2} />
      <TabBar
        tabs={tabs}
        selectedTabId={selectedTabId}
        onSelectTab={(tabId) =>
          navigate(tabId === "groups" ? "/groups" : "/users")
        }
      />
      <HorizontalSpacer spacing={2} />
      <Row nogutter align="center" justify="between">
        <TitleSmall color={theme.colors.primary}>
          {selectedTabId === "users" ? t("users.users") : t("users.groups")}
        </TitleSmall>
        <OutlinedButton
          title={
            selectedTabId === "users" ? t("users.addUser") : t("users.addGroup")
          }
          medium
          color={theme.colors.primary}
          icon={<AddIcon color={theme.colors.primary} />}
          onClick={() =>
            selectedTabId === "users"
              ? setAddUserOpen(true)
              : setAddGroupOpen(true)
          }
        />
      </Row>
      <HorizontalSpacer spacing={1} />

      {selectedTabId === "users" && (
        <UsersList
          onUserDeleted={() => setToastMessage(t("users.userDeletedMessage"))}
          onUserUpdated={() => setToastMessage(t("users.userUpdatedMessage"))}
        />
      )}
      {selectedTabId === "groups" && <GroupsList />}

      {addUserOpen && (
        <Modal closeIcon onClose={() => setAddUserOpen(false)} width={1000}>
          <div>
            <ManageUserModalContent
              onClose={() => setAddUserOpen(false)}
              onSuccess={() => setToastMessage(t("users.userCreatedMessage"))}
            />
          </div>
        </Modal>
      )}
      {addGroupOpen && (
        <Modal closeIcon onClose={() => setAddGroupOpen(false)} width={1400}>
          <div>
            <ManageGroupModalContent
              onClose={() => setAddGroupOpen(false)}
              onSuccess={() => setToastMessage(t("users.groupCreatedMessage"))}
            />
          </div>
        </Modal>
      )}
      {toastMessage && (
        <Toast
          type="success"
          title={toastMessage}
          onClose={() => setToastMessage(null)}
        />
      )}
    </div>
  );
};

export default UserManagmentPage;
